import React from 'react';
import { Link } from 'react-router-dom';
import { DictionaryService } from '../services/dictionaryService';

const WordLists = ({ headingLevel = 3, className = '' }) => {
  const Heading = `h${headingLevel}`;

  return (
    <div className={`grid gap-10 sm:grid-cols-2 lg:grid-cols-4 ${className}`}>
      {DictionaryService.getWordLists().map((list) => (
        <div key={list.name}>
          <Heading className="text-[0.95rem] font-semibold text-ink">{list.name}</Heading>
          <ul className="mt-3 space-y-1.5">
            {list.words.map((word) => (
              <li key={word}>
                <Link
                  to={`/define/${word}`}
                  className="rounded-sm font-serif text-xl text-ink decoration-mark decoration-4 underline-offset-4 hover:underline"
                >
                  {word}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default WordLists;
